module.exports = __webpack_public_path__ + "static/title_makonari-allbirds-f3675b93113151e662f1f4bc072e3d03.png";